import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Checkbox, { StyledInputWrapper } from '../../../atoms/Checkbox';
import ErrorLabel from '../../../atoms/labels/ErrorLabel';
import { Popover } from '../../../atoms/Popover/Popover';
import styled from 'styled-components';
function add(array) {
    return (element) => [...array, element];
}
function del(array) {
    return (element) => array.filter(v => v !== element);
}
const Checkboxes = ({ data, setData, errors = {}, availableColumns, }) => {
    const availableColumnNames = Object.keys(availableColumns);
    const allSelected = availableColumnNames?.every(columnName => data.export_columns?.includes(columnName));
    return (_jsxs(CheckboxesContainer, { children: [_jsx(Checkbox, { label: "Alles selecteren", checked: allSelected, indeterminate: !allSelected && data.export_columns.length > 0, onChange: () => allSelected
                    ? setData('export_columns', [])
                    : setData('export_columns', [...availableColumnNames]) }), availableColumnNames.map(columnName => (_jsx(Popover, { i18nextKey: `report.columnDescription.${columnName}`, children: _jsx(Checkbox, { label: availableColumns[columnName], checked: data.export_columns.includes(columnName), onChange: () => data.export_columns.includes(columnName)
                        ? setData('export_columns', del(data.export_columns)(columnName))
                        : setData('export_columns', add(data.export_columns)(columnName)) }) }, columnName))), errors?.export_columns && (_jsx(ErrorLabel, { children: errors?.export_columns }))] }));
};
const CheckboxesContainer = styled.div `
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    ${StyledInputWrapper} {
        margin: 0;
    }
`;
export default Checkboxes;
